import { render, staticRenderFns } from "./EditarSubMenu.vue?vue&type=template&id=37d51d1e"
import script from "./EditarSubMenu.vue?vue&type=script&lang=js"
export * from "./EditarSubMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports